import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { StudyProvider } from './context/StudyContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import Login from './components/Login';
import Register from './components/Register';
import Dashboard from './components/Dashboard';
import LandingPage from './components/LandingPage'; 
import StudyPack from './components/StudyPack';
import Progress from './components/Progress';
import CustomStudySession from './components/CustomStudySession';
import Question from './components/Question';
import Results from './components/Results';
import Prep from './components/Prep';
import PrepProgress from './components/PrepProgress';
import MockTest from './components/MockTest';
import MockProgress from './components/MockProgress';
import ReviewAnswers from './components/ReviewAnswers';
import AdminDashboard from './components/admin/AdminDashboard';
import AdminUsers from './components/admin/AdminUsers';
import AdminUserDetail from './components/admin/AdminUserDetail';
import AdminUserCreate from './components/admin/AdminUserCreate';
import AdminUserEdit from './components/admin/AdminUserEdit';
import QuestionsList from './components/admin/QuestionsList';
import QuestionDetail from './components/admin/QuestionDetail';
import QuestionForm from './components/admin/QuestionForm';
import QuestionStats from './components/admin/QuestionStats';
import BulkImport from './components/admin/BulkImport';

function App() {
  return (
    <AuthProvider>
      <StudyProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          
          <Route path="/" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }>
            <Route path='/' element={<LandingPage />} /> 
            <Route path="study-pack" element={<StudyPack />} />
            <Route path="progress" element={<Progress />} />
            <Route path="prep" element={<Prep />} />
            <Route path="prep-progress" element={<PrepProgress />} />
            <Route path="mock-test" element={<MockTest />} />
            <Route path="mock-progress" element={<MockProgress />} />
            <Route path="custom-study" element={<CustomStudySession />} />
            <Route path="question" element={<Question />} />
            <Route path="results" element={<Results />} />
            <Route path="/review-answers" element={<ReviewAnswers />} />
          </Route>
          
          {/* Admin Routes */}
          <Route path="/admin" element={
            <AdminRoute>
              <Dashboard />
            </AdminRoute>
          }>
            <Route index element={<AdminDashboard />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="users/create" element={<AdminUserCreate />} />
            <Route path="users/:userId" element={<AdminUserDetail />} />
            <Route path="users/:userId/edit" element={<AdminUserEdit />} />
            <Route path="questions" element={<QuestionsList />} />
            <Route path="questions/new" element={<QuestionForm />} />
            <Route path="questions/stats" element={<QuestionStats />} />
            <Route path="questions/bulk-import" element={<BulkImport />} />
            <Route path="questions/:id" element={<QuestionDetail />} />
            <Route path="questions/:id/edit" element={<QuestionForm />} />
          </Route>
          
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </StudyProvider>
    </AuthProvider>
  );
}

export default App;
